import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import TicketSaleTargetForm from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleTargetForm'
import useSalesManagementBreadcrumbs from 'Services/SalesManagement/Hooks/useSalesManagementBreadcrumbs'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function TicketSaleTargetCreatePage() {
  const title = t`Create a new ticket sale target`
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/ticket-sale-targets`
  const previousLocation = usePreviousLocation(baseUrl)
  const breadcrumbs = useSalesManagementBreadcrumbs([
    {
      title: t`Ticket sales`
    },
    {
      title: t`Ticket sale targets`,
      link: baseUrl
    },
    {
      title: title
    }
  ])

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{title}</PageTitle>
        </Grid>
      </Grid>
      <TicketSaleTargetForm successBaseUrl={previousLocation} />
    </Box>
  )
}
